import { useState } from 'react';
import { useModal } from '@/components/modals/Modal';
import { Loader } from '@/components/generic/Loader';
import {
  CreateNoteButton_NotebookFragment,
  useCreateNoteButton_NoteCreateMutation,
} from '@/graphql/generated';
import { UpdateNoteModal } from './UpdateNoteModal';
import { EditIcon } from '@/components/icons';
import { useTranslation } from '@/hooks/useTranslation';

export function CreateNoteButton({
  notebook,
  className = '',
  disabled = false,
}: {
  notebook: CreateNoteButton_NotebookFragment;
  className?: string;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const modal = useModal();
  const [createNoteMutation] = useCreateNoteButton_NoteCreateMutation();
  const [isLoading, setIsLoading] = useState(false);

  const createNote = () => {
    setIsLoading(true);
    createNoteMutation({
      variables: {
        input: {
          notebook: {
            id: notebook.id,
          },
          title: t('notebook.note.create.title'),
        },
      },
    })
      .then((res) => {
        if (res.data?.noteCreate) {
          modal.openModal(<UpdateNoteModal note={res.data?.noteCreate} />, {
            displayTitleBar: false,
            widthClass: 'w-3xl',
            padding: 'p-0',
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <button
      disabled={isLoading || disabled}
      onClick={() => createNote()}
      className={className}
    >
      {isLoading ? <Loader /> : <EditIcon className="w-4 h-4" />}
      {t('notebook.note.create.button')}
    </button>
  );
}
